<div class="flex items-center">
    <div class="flex items-center gap-3">
        @if (icon()) {
            <fa-icon
                class="pl-3"
                [class]="iconColor() ?? ''"
                [class.cursor-pointer]="isIconAction()"
                [icon]="icon()!"
                [size]="iconSize() ?? 'xl'"
                (click)="onIconClick()" />
        }
        <span [class]="`font-medium text-2xl ${titleSize() ?? ''}`">
            {{ title() }}
        </span>
        @if (subtitle()) {
            <span class="text-body-2 text-on-surface">{{ subtitle() }}</span>
        }
    </div>

    <ng-content />
</div>
